import api from '../../mdms_api';

export default async enclosureId => {
  try {
    const response = await api.get(
      // eslint-disable-next-line max-len
      `/api/v2/cms/sites/www.owenscorning.com/published?filter[type]=Cms::Content::Product::Enclosure&filter[content_uuid]=${enclosureId}&include=documents_zip_file`
    );
    return response.ok ? response.json() : null;
  } catch {
    return null;
  }
};
